import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check, Leaf } from "lucide-react";
import { PROGRAMS, getProgram } from "@/programs";

export default function ProgramPage() {
  const { slug } = useParams();
  const program = getProgram(slug);
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  if (!program) return <Navigate to="/" replace />;
  const others = PROGRAMS.filter((item) => item.slug !== slug);

  return <div className="program-page" data-testid={`program-page-${slug}`}>
    <header className="navbar"><Link className="brand" to="/" data-testid="program-brand-link"><span className="brand-mark"><Leaf size={17} /></span><span>fitnurish<em>.com</em></span></Link><nav className="nav-links program-nav"><Link to="/" data-testid="program-back-link"><ArrowLeft size={15} /> Back home</Link><Link className="nav-cta" to={`/?goal=${program.goal}#consultation`} data-testid="program-nav-consultation-link">Free consultation <ArrowRight size={16} /></Link></nav></header>

    <section className="program-hero section-pad">
      <div className="program-hero-copy">
        <p className="eyebrow"><span className="eyebrow-line" /> PROGRAMME {program.number}</p>
        <h1 data-testid="program-title">{program.title}<br /><i>{program.italic}</i></h1>
        <p className="hero-text" data-testid="program-intro">{program.intro}</p>
        <Link className="button button-dark" to={`/?goal=${program.goal}#consultation`} data-testid="program-hero-consultation-link">Book a free consultation <ArrowRight size={17} /></Link>
      </div>
      <div className="hero-visual program-visual"><img src={program.image} alt={program.imageAlt} data-testid="program-image" /></div>
    </section>

    <section className="program-expect" aria-label="What to expect">
      <div className="section-pad result-stats program-stats" data-testid="program-stats">{program.expect.map((item) => <div key={item.label}><strong>{item.value}</strong><span>{item.label}</span></div>)}</div>
    </section>

    <section className="program-body section-pad">
      <aside className="program-for" data-testid="program-for-you">
        <p className="eyebrow">THIS IS FOR YOU IF</p>
        <ul>{program.forYou.map((item) => <li key={item}><Check size={15} /> {item}</li>)}</ul>
      </aside>
      <div className="program-included" data-testid="program-included">
        <p className="eyebrow">WHAT'S INCLUDED</p>
        <h2>Everything you need,<br /><i>nothing you don't.</i></h2>
        <div className="included-grid">{program.included.map((item, index) => <article key={item.title}><span className="number">0{index + 1}</span><h3>{item.title}</h3><p>{item.text}</p></article>)}</div>
      </div>
    </section>

    {program.results?.length > 0 && <section className="program-results section-pad" data-testid="program-results">
      <div className="section-intro"><p className="eyebrow"><span className="eyebrow-line" /> REAL RESULTS</p><h2>Real people,<br /><i>real change.</i></h2><p>Our clients, before and after their FitNurish journey. Shared with their permission.</p></div>
      <div className="results-gallery">{program.results.map((item, index) => <figure key={item.image} data-testid={`program-result-${index}`}><img src={item.image} alt={item.alt} loading="lazy" /><figcaption><span>Before</span><span>After</span></figcaption></figure>)}</div>
    </section>}

    <section className="program-faq section-pad" data-testid="program-faq">
      <p className="eyebrow">COMMON QUESTIONS</p>
      <div className="faq-grid">{program.faq.map((item) => <div className="faq-item" key={item.q}><h3>{item.q}</h3><p>{item.a}</p></div>)}</div>
    </section>

    <section className="program-cta section-pad">
      <div className="program-cta-card">
        <div><p className="eyebrow">YOUR NEXT STEP</p><h2>Ready to start?<br /><i>Your first chat is free.</i></h2></div>
        <Link className="button button-dark" to={`/?goal=${program.goal}#consultation`} data-testid="program-cta-consultation-link">Request a free consultation <ArrowRight size={17} /></Link>
      </div>
      <div className="other-programs" data-testid="other-programs"><span>Also explore</span>{others.map((item) => <Link key={item.slug} to={`/${item.slug}`} data-testid={`other-program-${item.slug}`}>{item.title} <ArrowRight size={14} /></Link>)}</div>
    </section>

    <footer className="footer"><Link className="brand light" to="/"><span className="brand-mark"><Leaf size={17} /></span><span>fitnurish<em>.com</em></span></Link><p>Real wellness. Made for real life.</p><span>© 2025 FitNurish · <Link className="owner-link" to="/admin">Owner login</Link></span></footer>
  </div>;
}
